import React from "react"
import Box from '@mui/material/Box'
import Carousel from 'react-bootstrap/Carousel'
import Stack from '@mui/material/Stack'

export default function CustomCarousel(props) {
    const {
        carouselData,
        index,
        handleSelect,
        controls, 
        indicators, 
        showTexts, 
        topOffset, 
        bottomOffset,
        carouselSize,
    } = props

    return (<>
        <Box 
            sx={{ 
                mt: topOffset,
                mb: bottomOffset,
                mx: 5,
                // mr: 2.5,
                // ml: 2.5,
                width: carouselSize,
                height: carouselSize,
            }}
        >
            <Stack 
                direction="row"
                justifyContent="space-around"
                alignItems="stretch"
                spacing={1}
            >             
                <Carousel
                    activeIndex={index} 
                    onSelect={handleSelect}
                    interval={null}
                    variant="dark"
                    fade={true}
                    controls={controls}
                    indicators={indicators}
                >
                    {carouselData.map((data, index) => {   
                        return  (     
                                <Carousel.Item key={index}>
                                    <Box 
                                        key={index}
                                        sx={{
                                            width: carouselSize + 75,
                                            height: carouselSize + 25,
                                        }}
                                    >
                                        <Stack 
                                            direction="column"
                                            alignItems="center"
                                            spacing={5}
                                            sx={{ 
                                                pb: 5,
                                            }}
                                        >    
                                            <img 
                                                src={data.image}
                                                alt="not found" 
                                                width={carouselSize - 25} 
                                                height={carouselSize - 25}                   
                                            />
                                            {showTexts ? 
                                            <>
                                                {/* <Carousel.Caption> */}
                                                    {/* <h4>
                                                        <a href={data.link}>
                                                            {data.headerText}
                                                        </a>
                                                    </h4> */}
                                                    {/* <p>{data.subText}</p> */}
                                                {/* </Carousel.Caption> */}
                                                </>
                                            :
                                                null
                                            }
                                        </Stack>     
                                    </Box>
                                </Carousel.Item>
                        )
                    })}           
                </Carousel>
            </Stack>
        </Box>
    </>)
}

CustomCarousel.defaultProps = {
    carouselData: [],
    showTexts: true,
    topOffset: 5,
    bottomOffset: 15,
    carouselSize: 300
}